import { brands } from 'Constants';
import { isArray } from 'lodash';

const socials = {};

socials[brands.ABCBS] = {
  facebook: 'http://www.facebook.com/anthembluecrossblueshield',
  twitter: 'https://twitter.com/anthembcbs',
  youtube: 'https://www.youtube.com/channel/UCz_JdRQ9fpFoVFn8bqjRndw'
};

socials[brands.BCNY] = {
  facebook: 'https://www.facebook.com/AnthemBlueCrossBlueShield/',
  twitter: 'https://twitter.com/anthembcbs?lang=en',
  youtube: 'https://www.youtube.com/channel/UCz_JdRQ9fpFoVFn8bqjRndw'
};



socials[brands.BCBSNY] = {
  facebook: 'http://www.facebook.com/anthembluecrossblueshield',
  twitter: 'https://twitter.com/anthembcbs',
  youtube: 'https://www.youtube.com/channel/UCz_JdRQ9fpFoVFn8bqjRndw'
};

socials[brands.ABC] = {
  facebook: 'https://www.facebook.com/AnthemBlueCrossCA/',
  twitter: 'https://twitter.com/anthembluecross',
  youtube: 'https://www.youtube.com/channel/UC2jF4lNwBp8P2U4Vu3Y2Rkw'
};



socials[brands.EBCBS] = {
  facebook: 'https://www.facebook.com/EmpireBlueCrossBlueShield/',
  twitter: 'https://twitter.com/empirebcbs',
  youtube: 'https://www.youtube.com/channel/UCeHj_hYf8hkAEG8ct0DHL0g'
};

socials[brands.EBC] = {
  facebook: 'https://www.facebook.com/EmpireBlueCrossBlueShield/',
  twitter: 'https://twitter.com/empirebcbs',
  youtube: 'https://www.youtube.com/channel/UCeHj_hYf8hkAEG8ct0DHL0g'
};



socials[brands.Anthem_HK] = {
  facebook: 'http://www.facebook.com/anthembluecrossblueshield',
  twitter: 'https://twitter.com/anthembcbs',
  youtube: 'https://www.youtube.com/channel/UCz_JdRQ9fpFoVFn8bqjRndw'
};

socials[brands.ABCV] = {
  facebook: 'http://www.facebook.com/anthembluecrossblueshield',
  twitter: 'https://twitter.com/anthembcbs',
  youtube: 'https://www.youtube.com/channel/UCz_JdRQ9fpFoVFn8bqjRndw'
};


export default state =>{ 
  if(!state.brandID || isArray(state.brandID)){
    state.brandID = brands.ABC;
  
  }
  state.socials = socials[state.brandID]};
